
import React from "react";
import { useLocation, Route, Switch, Redirect } from "react-router-dom";
// reactstrap components
import { Container } from "reactstrap";
// core components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import Sidebar from "components/Sidebar/Sidebar.js";

import routes from "routes.js";

const Admin = (props) => {
  const mainContent = React.useRef(null);
  const [showNav,setShowNav] = React.useState(true);
  const location = useLocation();

  React.useEffect(() => {
    {
      let pathname = window.location.href.split("/");
        console.log("event.pathname",window.location.href,pathname);
        console.log('pathname[3].toLocaleLowerCase()', pathname[3].toLocaleLowerCase());
        console.log('pathname[3].toLowerCase()', pathname[3].toLowerCase());
        if(pathname[3]==="" || pathname[4].toLocaleLowerCase()==="viewPDF" ){
          setShowNav(false)
        }
  }
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  const getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (
        props.location.pathname.indexOf(routes[i].layout + routes[i].path) !==
        -1
      ) {
        return routes[i].name;
      }
    }
    return "Brand";
  };

  return (
    <>
      {/* {showNav &&
      <Sidebar
        {...props}
        routes={routes}
        logo={{
          innerLink: "/admin/index",
          imgSrc: require("../assets/img/brand/argon-react.png").default,
          imgAlt: "...",
        }}
      />
      } */}
      <div className="main-content" ref={mainContent}>
        {showNav && <AdminNavbar
          {...props}
          brandText={getBrandText(props.location.pathname)}
        />}
        <Switch>
          {getRoutes(routes)}
          <Redirect from="*" to="/admin/index" />
        </Switch>
       {/* {showNav && <Container fluid>
          <AdminFooter />
        </Container>} */}
      </div>
    </>
  );
};

export default Admin;
